// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue"
import App from "./App"
import VueCookie from "vue-cookie"
import router from "./router"
import store from "@/store"
import "@/assets/scss/index.scss"
import ElementUi from "element-ui"
import "element-ui/lib/theme-chalk/index.css"
import httpRequest from "@/utils/httpRequest"
import cloneDeep from "lodash/cloneDeep"
import "animate.css"
import "babel-polyfill"
import VueWechatTitle from "vue-wechat-title"
Vue.use(VueWechatTitle)
Vue.config.productionTip = false
Vue.use(ElementUi)
Vue.use(VueCookie)

Vue.prototype.$http = httpRequest
// 保存整站vuex本地储存初始状态
window.SITE_CONFIG["storeState"] = cloneDeep(store.state)

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store,
  components: { App },
  template: "<App/>",
})
// 设置浏览器标题
Vue.directive("title", {
  inserted: function(el, binding) {
    document.title = el.dataset.title
  },
})



// WEBPACK FOOTER //
// ./src/main.js